<template>
  <b-modal
    id="edit-subscription-modal"
    ref="edit-subscription-modal"
    centered
    :title="$t('DEBTIA_EDIT_SUBSCRIPTION')"
    :ok-title="$t('DEBTIA_SUBMIT')"
    cancel-variant="outline-secondary"
    size="md"
    no-close-on-backdrop
    @ok.prevent="EditSubscription"
    @hide="handleClose"
  >
    <b-overlay
      id="overlay-background"
      :show="loader"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-alert
        v-if="errorMsg"
        variant="warning"
        show
      >
        <div
          v-for="(error, index) in errorMsg"
          :key="index"
          class="alert-body"
        >
          <span v-if="errorMsg">{{ error }}</span>
        </div>
      </b-alert>
      <form
        ref="edit-subscription-form"
      >
        <validation-observer
          ref="editSubscriptionForm"
          tag="form"
        >
          <b-row>
            <b-col cols="12">
              <b-form-group
                label-for="subscription"
              >
                <validation-provider
                  #default="{ errors }"
                  name="subscription-start-date"
                  :rules="getRules(dateOption)"
                >
                  <b-form-group
                    :label="$t('DEBTIA_SUBSCRIPTION_START_DATE')"
                    :state="errors.length > 0 ? false:null"
                  >
                    <b-input-group>
                      <cleave
                        v-model="dasubscriptionStartDate"
                        class="form-control"
                        :raw="false"
                        :options="options.date"
                        placeholder="DD-MM-YYYY"
                        data-id="datepicker"
                        data-fieldtype="input"
                        @input="validateDate(0, dasubscriptionStartDate, 'startDate')"
                      />
                      <b-input-group-append>
                        <b-form-datepicker
                          v-model="subscriptionStartDate"
                          :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                          trim
                          button-only
                          right
                          size="sm"
                          data-id="datepicker"
                          data-fieldtype="input"
                          @input="validateDate(1, subscriptionStartDate, 'startDateFormatted')"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group
                label-for="subscription"
              >
                <validation-provider
                  #default="{ errors }"
                  name="subscription-End-date"
                  :rules="getRules(dateOption)"
                >
                  <b-form-group
                    :label="$t('DEBTIA_SUBSCRIPTION_END_DATE')"
                    :state="errors.length > 0 ? false:null"
                  >
                    <b-input-group>
                      <cleave
                        v-model="dasubcriptionEndDate"
                        class="form-control"
                        :raw="false"
                        :options="options.date"
                        placeholder="DD-MM-YYYY"
                        data-id="datepicker"
                        data-fieldtype="input"
                        @input="validateDate(0, dasubcriptionEndDate, 'endDate')"
                      />
                      <b-input-group-append>
                        <b-form-datepicker
                          v-model="subcriptionEndDate"
                          :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }"
                          trim
                          button-only
                          right
                          size="sm"
                          data-id="datepicker"
                          data-fieldtype="input"
                          @input="validateDate(1, subcriptionEndDate, 'endDateFormatted')"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <validation-provider
                #default="{ errors }"
                name="cancel-subscription"
                rules
              >
                <b-form-group
                  :state="errors.length > 0 ? false:null"
                  :label="$t('DEBTIA_CANCELLED_SUBSCRIPTION')"
                >
                  <b-form-radio-group
                    v-model="cancelSubscription"
                    name="cancel-subscription"
                    :options="radioOptions"
                    value-field="item"
                    text-field="name"
                    class="radio-style"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <validation-provider
                #default="{ errors }"
                name="auto-renew"
                rules="required"
              >
                <b-form-group
                  :state="errors.length > 0 ? false:null"
                  :label="$t('DEBTIA_AUTO_RENEW_SUBSCRIPTION')"
                >
                  <b-form-radio-group
                    v-model="autoRenewSubscription"
                    name="auto-renew"
                    :options="radioOptions"
                    value-field="item"
                    text-field="name"
                    class="radio-style"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
      </form>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BFormGroup, BFormDatepicker, BRow, BCol, BOverlay, BFormInvalidFeedback, BAlert, BInputGroupAppend, BInputGroup, BFormRadioGroup,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Cleave from 'vue-cleave-component'
import { EventBus } from '@/event-bus'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import axios from '@axios'

export default {
  components: {
    BOverlay,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
    BRow,
    BCol,
    BFormInvalidFeedback,
    BAlert,
    BInputGroupAppend,
    BInputGroup,
    Cleave,
    BFormRadioGroup,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
    editSubscription: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loader: false,
      subscriptionStartDate: '',
      dasubscriptionStartDate: '',
      subcriptionEndDate: '',
      dasubcriptionEndDate: '',
      cancelSubscription: '',
      autoRenewSubscription: '',
      errorMsg: '',
      options: {
        date: {
          date: true,
          delimiter: '-',
          datePattern: ['d', 'm', 'Y'],
        },
      },
      dateOption: '',
      radioOptions: [
        { item: 'true', name: 'True' },
        { item: 'false', name: 'False' },
      ],
    }
  },
  watch: {
    editSubscription: {
      handler(newVal) {
        if (newVal) {
          this.dasubscriptionStartDate = newVal.start_date || ''
          this.dasubcriptionEndDate = newVal.end_date || ''
          this.cancelSubscription = newVal.cancelled === 'DEBTIA_YES' ? 'true' : 'false'
          this.autoRenewSubscription = newVal.auto_renew === 'DEBTIA_YES' ? 'true' : 'false'
        }
      },
    },
  },
  methods: {
    getRules(option) {
      let validationRules = ''
      if (option === 1) {
        validationRules = 'required|datePattern'
      } else {
        validationRules = 'required'
      }
      return validationRules
    },
    validateDate(type, value, dateType) {
      const formattedDate = type === 0 ? this.$FormformattedDate(value) : this.$DAformattedDate(value)
      if (dateType === 'startDate') {
        this.subscriptionStartDate = formattedDate
      } else if (dateType === 'startDateFormatted') {
        this.dasubscriptionStartDate = formattedDate
      } else if (dateType === 'endDate') {
        this.subcriptionEndDate = formattedDate
      } else if (dateType === 'endDateFormatted') {
        this.dasubcriptionEndDate = formattedDate
      }
    },
    EditSubscription() {
      this.$refs.editSubscriptionForm.validate().then(success => {
        if (success) {
          this.loader = true
          const url = `${constants.baseUrl}/client/subscription/entry/update`
          const obj = {
            client_id: this.userData.data.id,
            startDate: this.subscriptionStartDate,
            endDate: this.subcriptionEndDate,
            cancelled: this.cancelSubscription === 'true',
            autoRenew: this.autoRenewSubscription === 'true',
            entryNo: this.editSubscription.entry_no,
          }
          axios.post(url, obj).then(response => {
            this.loader = false
            if (response.status === 200) {
              this.$refs['edit-subscription-modal'].hide()
              EventBus.$emit('client-updated')
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Success',
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: i18n.t('DEBTIA_SUBSCRIPTION_UPDATED_SUCCESSFULLY'),
                },
              })
              EventBus.$emit('refereshNotes')
              this.subscriptionStartDate = ''
              this.dasubscriptionStartDate = this.editSubscription.start_date
              this.subcriptionEndDate = ''
              this.dasubcriptionEndDate = this.editSubscription.end_date
              this.cancelSubscription = ''
              this.autoRenewSubscription = ''
            }
          }).catch(error => {
            this.loader = false
            this.errorMsg = error.response.data.message
          })
        }
      })
    },
    handleClose(evt) {
      if (evt.trigger !== 'ok') {
        this.cancelModal()
      }
    },
    cancelModal() {
      this.errorMsg = ''
      this.cancelSubscription = ''
      this.autoRenewSubscription = ''
      this.dasubscriptionStartDate = this.editSubscription.start_date
      this.dasubcriptionEndDate = this.editSubscription.end_date
      this.cancelSubscription = this.editSubscription.cancelled === 'DEBTIA_YES' ? 'true' : 'false'
      this.autoRenewSubscription = this.editSubscription.auto_renew === 'DEBTIA_YES' ? 'true' : 'false'
    },
  },
}

</script>

<style>
.radio-style{
    margin-top: 1rem;
}
</style>
